import cx from "classnames";
import React, { ChangeEventHandler } from "react";
import { Icon } from "../components/Icon";
import styles from "./Checkbox.module.css";

export type CheckboxProps = {
  value: string;
  label: string;
  checked?: boolean;
  disabled?: boolean;
  wrap?: boolean;
  name?: string;
  onChange?: ChangeEventHandler;
};

export const CheckboxComponent = ({
  label,
  value,
  checked,
  disabled = false,
  name,
  wrap = false,
  onChange,
}: CheckboxProps) => {
  return (
    <label
      className={cx(
        styles.label,
        { [styles.disabled]: disabled },
        { [styles.wrap]: wrap }
      )}
    >
      <span className={styles.container}>
        <input
          type="checkbox"
          key={value}
          defaultChecked={checked}
          name={name || value}
          disabled={disabled}
          onChange={onChange}
        />
        <span className={styles.fakeCheckBox}>
          <Icon icon="check" />
        </span>
      </span>
      {wrap ? <span className={styles.text}>{label}</span> : <>{label}</>}
    </label>
  );
};

export const Checkbox = React.memo(CheckboxComponent);
